
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 26 26","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.622 4.342A12 12 0 0013.078.8C6.421.8 1.002 6.218 1 12.877c-.001 2.13.555 4.207 1.612 6.039L.898 25.175l6.403-1.68c1.765.963 3.75 1.47 5.772 1.47h.005c6.657 0 12.076-5.418 12.079-12.078a12.004 12.004 0 00-3.535-8.545zm-8.544 18.584h-.004c-1.801-.001-3.568-.485-5.11-1.4l-.366-.218-3.8.997 1.014-3.704-.238-.38a10.014 10.014 0 01-1.535-5.343C3.04 7.343 7.545 2.84 13.082 2.84a9.97 9.97 0 017.098 2.944 9.98 9.98 0 012.937 7.102c-.002 5.536-4.505 10.04-10.039 10.04zm5.507-7.52c-.302-.15-1.786-.88-2.063-.981-.276-.101-.477-.151-.678.15-.202.303-.78.983-.956 1.184-.176.201-.352.227-.654.076-.302-.151-1.274-.47-2.427-1.498-.897-.8-1.503-1.789-1.679-2.09-.176-.303-.001-.45.133-.617.326-.405.653-.83.754-1.032.1-.202.05-.378-.025-.529-.076-.15-.68-1.636-.93-2.24-.246-.59-.494-.51-.68-.519-.176-.009-.377-.01-.578-.01-.201 0-.528.075-.805.377S6.94 8.71 6.94 10.195c0 1.486 1.081 2.92 1.232 3.122.15.201 2.128 3.25 5.156 4.557.72.311 1.282.497 1.72.636.723.23 1.381.197 1.901.12.58-.087 1.785-.73 2.037-1.436.252-.705.252-1.309.176-1.435-.075-.126-.276-.201-.578-.352z","fill":"currentColor"}})])
          )
        }
      }
    